import { head } from 'lodash/fp';

import { GET_OFFER_TERMS } from './query.gql';
import useOfferQuery from '../use-offer-query';

const useGetOfferTerms = (offerId: string) => {
  const { data, loading } = useOfferQuery(GET_OFFER_TERMS, {
    variables: { id: offerId },
  });
  return {
    loading,
    offer: head(data?.allOffer),
  };
};

export default useGetOfferTerms;
